import { render, staticRenderFns } from "./AccountRequestDataAdministrationCampaigns.vue?vue&type=template&id=b2f88862&scoped=true"
import script from "./AccountRequestDataAdministrationCampaigns.vue?vue&type=script&lang=js"
export * from "./AccountRequestDataAdministrationCampaigns.vue?vue&type=script&lang=js"
import style0 from "./AccountRequestDataAdministrationCampaigns.vue?vue&type=style&index=0&id=b2f88862&prod&scoped=true&lang=css"
import style1 from "./AccountRequestDataAdministrationCampaigns.vue?vue&type=style&index=1&id=b2f88862&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f88862",
  null
  
)

export default component.exports